/* eslint-disable no-console */
function initComparisons() {
  var slider, sliderElements, overlayElements, backgroundElements, overlay, background;
  var height;
  var isClicked = false;
 

  sliderElements = document.getElementsByClassName("slider-wrapper");
  overlayElements = document.getElementsByClassName("img-comp-overlay");
  backgroundElements = document.getElementsByClassName("img-comp-wrapper");

  slider = sliderElements[0];
  overlay = overlayElements[0];
  background = backgroundElements[0];

  if (!slider || !overlay || !background) return;

  slider.addEventListener("mousedown", readySlide);
  slider.addEventListener("touchstart", readySlide)
  slider.addEventListener("mouseup", finishSlide);
  slider.addEventListener("touchend", finishSlide)
  overlay.addEventListener("mouseup", finishSlide);
  overlay.addEventListener("touchend", finishSlide)
  background.addEventListener("mousemove", function (event) {
    slideMove(event);
  });
  background.addEventListener("touchmove", function (event) {

    slideMove(event);
  }); 
  slider.addEventListener("touchmove", function (event) {
    slideMove(event);
  });

  function prepSlide() {

    if (sliderElements && overlayElements) {

      height = overlay.offsetHeight
      slider.style.top = (height - (slider.offsetHeight)) + "px";
      console.log(height
      );
    }
  };

  if (window.addEventListener) {
    window.addEventListener('load', prepSlide); 
  }
  
  function readySlide(event) {
    isClicked = true;
    event.preventDefault();
    console.log('Slider is ready'); 
  };

  function slideMove(event) {
    if (!isClicked) return; 
    var rect = background.getBoundingClientRect();
    var y;
    var sliderBottom; 
   
    if (event.type === "touchmove") {
      y = event.touches[0].clientY - rect.top;
    } else {
      y = event.clientY - rect.top;
    }

    slider.style.top = y + "px";
    overlay.style.height = (y + 10) + "px";
    sliderBottom = y + slider.offsetHeight; 

    if (parseInt(slider.style.top) < (0.11 * background.offsetHeight)) {
      slider.style.top = (0.11 * background.offsetHeight) + "px";
      overlay.style.height = (0.10 * background.offsetHeight + 10) + "px";
    } else if (sliderBottom > (0.90 * background.offsetHeight)) {
      slider.style.top = (0.88 * background.offsetHeight) + "px"; 
    }
  };

  function finishSlide() {
    isClicked = false;
    console.log('Slider has been released');
  }

}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function activateComparisonSlider() {
  const imgCompSlider = document.querySelector('.img-comp-slider');
  const imgCompOverlay = document.querySelector('.img-comp-overlay');

  if (isInViewport(comparisonContainer)) {
    console.log(comparisonContainer + "is in full view")
    imgCompSlider.classList.add('img-comp-slider-animation');
  }
}

export default {
  initComparisons,
};
